import FullIndex from './full.vue';
import MobIndex from './mob-full.vue';

export const componentMap = {
    full: FullIndex,
    'mob-full': MobIndex
};